import React from 'react';

import { AchievementUnlockedModal } from '../../screens/dashboard/user/AchievementUnlockedModal';
import { LevelUpModal } from '../../screens/dashboard/user/LevelUpModal';
import { MilestoneCelebrationModal } from '../../screens/dashboard/user/MilestoneCelebrationModal';
import { useCelebration } from './CelebrationContext';

/**
 * The detailed celebration screens (CORE-272 and siblings).
 *
 * CORE-509 changed WHEN these appear, not what they are. They used to open by
 * themselves on a pending event, and only inside the profile tree. Now Agapella
 * greets the move in her pop-up — wherever the user is — and these open only
 * when the user takes her up on «Посмотреть» (`detailsOpen`).
 *
 * That keeps both halves doing what each is good at: she carries the meaning,
 * the screen carries the facts — medallion, progress, the rights that actually
 * opened, share. Neither duplicates the other.
 *
 * Mounted once at the app root. Both gates — the runtime flag and CORE-746's
 * «a master receives no congratulations» — live in the provider now, so a
 * disabled environment or a master never fetches and never surfaces anything
 * here.
 */
export const GamificationCelebrationHost: React.FC = () => {
  const { event, detailsOpen, dismiss } = useCelebration();

  // Nothing to show until she has been asked for the details.
  const shown = detailsOpen ? event : null;

  // Ничего не показываем — ничего и не монтируем. Смонтированное окно исполняет
  // свои хуки и в скрытом виде: именно так `useSafeAreaInsets` из
  // AchievementUnlockedModal (CORE-703) валил каждую страницу, пока хост живёт
  // в корне. Провайдер вокруг хоста это чинит, но само окно, которое никто не
  // видит, не должно ничего исполнять.
  if (!shown) return null;

  return (
    <>
      <LevelUpModal
        visible={shown?.type === 'level_up'}
        event={shown?.type === 'level_up' ? shown : null}
        onClose={dismiss}
      />
      <AchievementUnlockedModal
        visible={shown?.type === 'achievement_earned'}
        event={shown?.type === 'achievement_earned' ? shown : null}
        onClose={dismiss}
      />
      <MilestoneCelebrationModal
        visible={shown?.type === 'milestone_reached' || shown?.type === 'new_record'}
        event={
          shown?.type === 'milestone_reached' || shown?.type === 'new_record' ? shown : null
        }
        onClose={dismiss}
      />
    </>
  );
};
